import React from 'react';
import { faRoad } from '@fortawesome/pro-regular-svg-icons/faRoad';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function RoadRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faRoad} {...props} />;
}
